export default __webpack_public_path__ + "static/media/tots.5ac8e5de.jpg";